jQuery('.mobie-sctin-sldr, .banner_rightinner').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
   autoplay:true,
  adaptiveHeight: true,
  prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></div>',
  nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></div>'
});


function initializeSlickSlider() {
    jQuery('.special_items .special_grid').slick({
       dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: '20px', 
      });
}

function checkWindowSize() {
    if (jQuery(window).width() <= 768) { // Mobile devices (768px or less)
        if (!jQuery('.special_items .special_grid').hasClass('slick-initialized')) {
            initializeSlickSlider();
        }
    } else {
        if (jQuery('.special_items .special_grid').hasClass('slick-initialized')) {
            jQuery('.special_items .special_grid').slick('unslick');
        }
    }
}

jQuery(document).ready(function() {
    checkWindowSize();
    jQuery(window).resize(function() {
        checkWindowSize();
    });
});

document.addEventListener("DOMContentLoaded", function () {
const headers = document.querySelectorAll(".accordion-header");

headers.forEach(header => {
    header.addEventListener("click", function () {
     const content = this.nextElementSibling;
     const icon = this.querySelector(".accordion-icon");

     // Close others (optional)
     document.querySelectorAll(".accordion-content").forEach(item => {
        if (item !== content) {
            item.style.display = "none";
            item.previousElementSibling.querySelector(".accordion-icon").textContent = "+";
        }
     });

     // Toggle current
     if (content.style.display === "block") {
        content.style.display = "none";
        icon.textContent = "+";
     } else {
        content.style.display = "block";
        icon.textContent = "-";
     }
    });
});
});

